export const API_BASE_URL = "https://www.vyaparkranti.com/laravel";
export const API_ENDPOINTS = {
  TEST_DATA: "/api/api/get-test-data",
};

export const IMAGE_BASE_URL = API_BASE_URL;


// export const API_BASE_URL = "http://192.168.1.12:8000";
// export const API_ENDPOINTS = {
//   TEST_DATA: "/api/get-test-data",
//   HERO_DATA: "/api/home-elements",
// };

// export const IMAGE_BASE_URL = API_BASE_URL;